import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';
import { putRequest } from 'src/utils/request';
import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';

import messages from '../../messages';

const updatePayFine = async ({ uuid }: { uuid: string }) => {
  const payload = {
    uuid,
    type: 'fines',
  };

  const { data } = await putRequest(API.PUT.updatePayFine(uuid), payload);
  return data;
};

export const useUpdatePayFine = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: updatePayFine,
    onSuccess: () => {
      client.invalidateQueries({ queryKey: [QUERY_KEYS.FINES] });
      handleSuccess(formatMessage(messages.finePaid), 1000);
    },
    onError: handleError,
  });
};
